import { render, staticRenderFns } from "./UseCases.vue?vue&type=template&id=87995f58&scoped=true&"
import script from "./UseCases.vue?vue&type=script&lang=js&"
export * from "./UseCases.vue?vue&type=script&lang=js&"
import style0 from "./UseCases.vue?vue&type=style&index=0&id=87995f58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87995f58",
  null
  
)

export default component.exports